import React from 'react';
import { ActivityType, MoodId } from './moods';
import BreathingExercise from './activities/BreathingExercise';
import FocusTimer from './activities/FocusTimer';
import GroundingExercise from './activities/GroundingExercise';
import GratitudeActivity from './activities/GratitudeActivity';
import RelaxingVisual from './activities/RelaxingVisual';
import BubbleWorld from './visual/worlds/BubbleWorld';
import MoodGarden from './visual/worlds/MoodGarden';
import FlowingWaves from './visual/worlds/FlowingWaves';
import FloatingStars from './visual/worlds/FloatingStars';
import CalmPond from './visual/worlds/CalmPond';
import WorryRelease from './visual/worlds/WorryRelease';
import ZenGarden from './visual/worlds/ZenGarden';
import HappyBurst from './games/HappyBurst';
import OddOne from './games/OddOne';
import TinyWins from './games/TinyWins';
import GroundExplorer from './games/GroundExplorer';
import PowerUp from './games/PowerUp';

/**
 * MoodActivity — the one little interactive "world" or activity a mood opens.
 *
 * Shared by the MoodMate dashboard and the Mood Journal so a mood maps to exactly
 * one activity in one place. Every activity is optional, self-contained and easy
 * to leave; none is a work task or a required journal entry.
 */
export const MoodActivity: React.FC<{ type: ActivityType; mood?: MoodId }> = ({ type, mood }) => {
  switch (type) {
    case 'bubbles':
      return <BubbleWorld />;
    case 'garden':
      return <MoodGarden />;
    case 'waves':
      return <FlowingWaves />;
    case 'stars':
      return <FloatingStars />;
    case 'pond':
      return <CalmPond />;
    case 'release':
      return <WorryRelease />;
    case 'zen':
      return <ZenGarden />;
    case 'burst':
      return <HappyBurst />;
    case 'odd':
      return <OddOne />;
    case 'wins':
      return <TinyWins />;
    case 'explore':
      return <GroundExplorer />;
    case 'power':
      return <PowerUp />;
    case 'breathing':
      return <BreathingExercise />;
    case 'grounding':
      return <GroundingExercise />;
    case 'gratitude':
      return <GratitudeActivity />;
    case 'focus':
      return <FocusTimer presets={[25, 15, 50]} label="Focus block" doneMessage="Block complete — nice work." />;
    case 'rest':
      return <FocusTimer presets={[5, 10, 20]} label="Rest break" doneMessage="Break’s up — ease back in gently." />;
    case 'visual':
    case 'journal':
    default:
      return <RelaxingVisual mood={mood} />;
  }
};

export default MoodActivity;
